<template>
    <div class="more-nav-box">
        <a  class="item" :href="item.url" v-for="item in topNavigation" :key="item.name">{{ item.name }}</a>
    </div>
</template>
<script>
import LoginBtn from './LoginBtn.vue'
export default {
    components: {
        LoginBtn
    },
    data() {
        return {
            topNavigation: []
        }
    },
    mounted() {
        this.topNavigation = window.pcArticleInfo?.topNavigation.slice(10) || []
    },
    methods: {
        
    }
}
</script>
<style lang="less">
 /* .more-nav */

.more-nav:hover {
    border-top-color:transparent;
    .cor {
        transform:rotate(180deg);
    }
    .more-nav-box {
        visibility: visible;
        opacity: 1;
    }
}
.more-nav-box {
    width: 338px;
    height: 144px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.06), 0px 4px 10px -2px rgba(0,0,0,0.07);
    border: 1px solid rgba(0,0,0,0.02);
    visibility: hidden;
    opacity: 0;
    font-size: 14px;
    position:absolute;
    top:40px;
    left:50%;
    transform: translateX(-50%);
    text-align:center;
    padding: 14px 4px 4px 12px; // 右侧留8px用于margin-right的兼容
    transition: all .2s ease-in;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow: hidden;
    &::after{
        content: '';
        position: absolute;
        right: 50%;
        top: -16px;
        transform: translateX(50%);
        width: 0px;
        height: 0px;
        border-top: 8px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 8px solid #FFFFFF;
        border-left: 6px solid transparent;
        z-index: 1;
    }
    .item {
        display:inline-block;
        max-width: 88px !important;
        min-width: 56px !important;;
        width: fit-content !important;;
        height:32px !important;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666 !important;
        line-height: 22px;
        padding: 5px 12px;
        margin-right: 8px;
        margin-bottom: 8px;
        &:hover {
            background: #F8F8F8;
        }
    }
}
</style>